import ComponentGameMemory from 'models/componentInteraction/ComponentGameMemory';
import { GenericService } from '../Generic.service';
import ComponentGameMemoryCard from 'models/componentInteraction/ComponentGameMemoryCard';

export class ComponentGameMemoryService extends GenericService {
    readonly URI: string = '/v1/gameMemory';

    constructor() {
        super();
        this.setUri(this.URI);
    }

    async saveGame(body: ComponentGameMemory[], idComponentInteraction: number) {
        return await this.post('' + idComponentInteraction, body);
    }
    async saveGameOne(body: ComponentGameMemory, idComponentInteraction: number) {
        return await this.post('gameOne/' + idComponentInteraction, body);
    }

    async saveCard(body: ComponentGameMemoryCard, idComponentGame: number) {
        return await this.post('card/' + idComponentGame, body);
    }

    async deleteGame(idGame: number) {
        return await this.delete(idGame);
    }

    async deleteCard(idCard: number) {
        return await this.deleteByUrl(idCard, "card");
    }
}
